import { render, staticRenderFns } from "./AiAssistantTeamPrompts.vue?vue&type=template&id=388eb4a5&scoped=true&"
import script from "./AiAssistantTeamPrompts.vue?vue&type=script&lang=js&"
export * from "./AiAssistantTeamPrompts.vue?vue&type=script&lang=js&"
import style0 from "./AiAssistantTeamPrompts.vue?vue&type=style&index=0&id=388eb4a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388eb4a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388eb4a5')) {
      api.createRecord('388eb4a5', component.options)
    } else {
      api.reload('388eb4a5', component.options)
    }
    module.hot.accept("./AiAssistantTeamPrompts.vue?vue&type=template&id=388eb4a5&scoped=true&", function () {
      api.rerender('388eb4a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalHeader/modal/AiAssistantDrawer/AiAssistantTeamPrompts.vue"
export default component.exports